export default {
  siteUrl: "https://whoishakaton.rs",
  googleAnalyticsID: "123123",
  backgroundColor: "#121826",
  themeColor: "#B83532",
};
